import type React from 'react'
import { Outlet, useParams } from 'react-router-dom'
import { HeaderBar } from '@/components/main-page/header-bar'

export function OrgLayout(): React.ReactElement {
  const { orgSlug } = useParams<{ orgSlug: string }>()

  return (
    <div className="flex h-dvh flex-col bg-background">
      <HeaderBar orgSlug={orgSlug ?? ''} />
      <div className="flex-1 overflow-auto">
        <Outlet />
      </div>
    </div>
  )
}
